import request from '../../axios';

const postExtendRequirement = async (advertisement_id: string) => {
  await request.post(`/api/v2/store/requirement-extension/${advertisement_id}`);
};

export default postExtendRequirement;
